<template>
    <div class="card">
        <div class="card-header">
            <i class="fa fa-pencil"></i> {{ $t('checklist.update') }}
            <div class="card-actions">
                <router-link to='../list' style="cursor: pointer">
                    <small class="text-muted">
                        <i class="fa fa-arrow-left"></i></small>
                </router-link>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm-6">
                    <fieldset role="group" class="b-form-group form-group">
                        <div role="group" class="">
                            <label for="name"><i class="fa fa-check"></i> {{ $t('checklist.attribute.name') }} :</label>
                            <input id="name" type="text" :placeholder="$t('checklist.attribute.name')"
                                class="form-control" v-model="checklist.name">
                            <error :error="errors.name"></error>
                        </div>
                    </fieldset>
                    <fieldset role="group" class="b-form-group form-group">
                        <div role="group" class="">
                            <label for="year1"><i class="fa fa-calendar"></i>
                                {{ $t('checklist.attribute.starting_date') }} :</label>
                            <datetime type="date" format="dd-MM-yyyy" inputClass="form-control" tabindex="15"
                                :placeholder="$t('checklist.attribute.starting_date')"
                                v-model="checklist.starting_date"></datetime>
                            <error :error="errors.starting_date"></error>
                        </div>
                    </fieldset>
                    <b-form-group :label="$t('checklist.attribute.category')" label-for="basicCheckboxes"
                        :label-cols="3">
                        <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true"
                            :checked="ctg_id">
                            <treeselect :multiple="false" :flatten-search-results="true" :options="category"
                                :normalizer="normalizer_ctg" :flat="false" :placeholder="$t('filter.category')"
                                v-model="ctg_id" :default-expand-level="3" />
                            <error :error="errors.ctg"></error>
                        </b-form-checkbox-group>
                    </b-form-group>
                </div>
                <div class="col-sm-6">
                    <fieldset role="group" class="b-form-group form-group">
                        <div role="group" class="">
                            <label for="ccnumber"><i class="fa fa-sitemap"></i>
                                {{ $t('checklist.attribute.organization') }} :</label>
                            <treeselect :default-expand-level="2" :multiple="false"
                                :options="organizations" :normalizer="normalizer_org"
                                :placeholder="$t('checklist.attribute.organization')" v-model="checklist.org_id" />
                            <error :error="errors.org_id"></error>
                        </div>
                    </fieldset>
                    <fieldset role="group" class="b-form-group form-group">
                        <div role="group" class="">
                            <label for="cvv"><i class="fa fa-calendar"></i> {{ $t('checklist.attribute.ending_date') }}
                                :</label>
                            <datetime type="date" format="dd-MM-yyyy" inputClass="form-control" tabindex="15"
                                :placeholder="$t('checklist.attribute.ending_date')" v-model="checklist.ending_date">
                            </datetime>
                            <error :error="errors.ending_date"></error>
                        </div>
                    </fieldset>
                </div>
            </div>

            <fieldset role="group" class="b-form-group form-group" v-for="(group_alias, index) in group_aliases"
                :key="index">
                <label for="cvv"><i class="fa fa-users"></i> {{ group_alias.alias }} :</label>
                <div role="group" class="" v-if="users_group[group_alias.id]">
                    <br>
                    <label for="" class="ml-3" v-for="(user, key) in users_group[group_alias.id].users" :key="key">
                        <img :src="user.avatar" alt="" width="24" class="rounded">
                        <span class="link"> {{ user.name }} ({{ user.email }}) </span>
                        <span class="link-delete" @click="destroyUser(group_alias.id, user)"> x </span>
                        <br><br>
                    </label>
                </div>
                <treeselect :multiple="true" :options="users" :normalizer="normalizer"
                    :placeholder="'Add ' + group_alias.alias" @select="select(group_alias.id, ...arguments)"
                    @deselect="deselect(group_alias.id, ...arguments)" :clearable="false" />

            </fieldset>
        </div>
        <div class="card-footer">
            <div class="pull-right">
                <button class="btn btn-sm btn-primary" @click="update()" :disabled="btn_submit"><i
                        class="fa fa-pencil"></i>
                    {{ $t('checklist.button.update') }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import lodash from 'lodash'
import Status from '@/status'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
export default {
  name: 'edit',
  components: { Datetime },
  props: [],
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.fullname + ' (' + node.email + ')',
          children: node.children
        }
      },
      normalizer_org (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      normalizer_ctg (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      loading: true,
      checklist: {
        user: []
      },
      btn_submit: false,
      errors: {},
      ctg_id: null,
      users_group: [],
      checklistId: this.$route.params.checklist_id
    }
  },
  computed: {
    category () {
      return this.$store.getters['CategoryChk/getListRecursive']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    },
    group_aliases () {
      return this.$store.getters['GroupAlias/getListGroupAlias']
    },
    users: {
      get: function () {
        return this.$store.getters['User/users']
      },
      set: function (value) {
        this.$store.commit('User/setData', value)
      }
    }
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('Organization/getData', { page: 1, per_page: 'all', status: Status.APPROVAL }),
      this.$store.dispatch('GroupAlias/getListGroupAlias', { per_page: 500 }),
      this.$store.dispatch('User/getData', { per_page: 'all', status: 0 }),
      this.$store.dispatch('Checklist/showChecklist', { checklist: { id: this.checklistId } }),
      this.$store.dispatch('Audit/getUserOfChecklist', { checklist: { id: this.checklistId } }),
      this.$store.dispatch('CategoryChk/getListCtg')
    ]).then(res => {
      this.checklist = res[3]
      this.ctg_id = res[3].category.id
      this.checklist.user = []
      this.checklist.org_id = res[3].organization.id
      res[1].forEach(element => {
        this.users_group[element.id] = { users: [], plus_users: [] }
      })
      res[4].forEach(element => {
        var index = lodash.findIndex(this.users, ['id', element.user_id])
        this.users.splice(index, 1)
        this.users_group[element.id].users.push(element)
      })
      console.log(this.users_group)
    }).catch(errors => {
      console.log(errors)
    })
  },
  methods: {
    select (index, node) {
      var i = lodash.findIndex(this.users, ['id', node.id])
      this.users.splice(i, 1)
      this.users_group[index].plus_users.push(node.id)
    },
    deselect (index, node) {
      var i = lodash.findIndex(this.users_group[index].plus_users, ['id', node.id])
      this.users_group[index].plus_users.splice(i, 1)
      this.users.push(node.id)
    },
    destroyUser (index, user) {
      var i = lodash.findIndex(this.users_group[index].users, ['id', user.user_id])
      this.users_group[index].users.splice(i, 1)
      this.users.push(user.user_id)
    },
    update () {
      var user = []
      this.users_group.forEach((element, index) => {
        if (element) {
          let uids = element.users.map(user => user.user_id)
          let combinedUsers = [...uids, ...element.plus_users]
          user.push({
            group_alias_id: index,
            users: combinedUsers
          })
        }
      })
      this.checklist.users = user
      this.btn_submit = true
      this.checklist.starting_date = this.checklist.starting_date ? this.$moment(this.checklist.starting_date).format('YYYY-MM-DD') : ''
      this.checklist.ending_date = this.checklist.ending_date ? this.$moment(this.checklist.ending_date).format('YYYY-MM-DD') : ''
      this.checklist.ctg = this.ctg_id ? this.checklist.category.id : this.ctg_id
      delete this.checklist.status
      this.$store.dispatch('Checklist/updateChecklist', { checklist: this.checklist }).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.$router.push('../list')
        this.btn_submit = false
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
      })
    }
  }
}
</script>
<style lang="scss">
label {
    font-weight: 700
}

.link-delete {
    color: red;
}

.link-delete:hover {
    color: red;
    cursor: pointer;
    text-decoration-line: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/checklist/edit/index.vue